export default __webpack_public_path__ + "static/media/14.548f00ce.mp3";